import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, AuthState } from '../services/auth.service';
import { REPORT_CONFIG } from 'app/components/new-navigation/rankings/REPORT_CONFIG';

@Injectable()
export class RankingsAnonymousGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const authState = this.auth.getAuthState();

    if (authState === AuthState.Anonymous) {
      const { type, rankingtype } = route.params;
      const reportConfig = REPORT_CONFIG.find(
        report => report.key == rankingtype
      );

      if (reportConfig) {
        const params = ['rankings', type, rankingtype];
        let reroute = false;

        reportConfig.mainFilterItems
          .filter(filter => !filter.groups || filter.groups.includes(type))
          .forEach((filter, idx) => {
            const paramValue = route.paramMap.get(`param${idx + 1}`);
            if (paramValue) {
              if (filter.default && filter.default.value != paramValue) {
                params.push(filter.default.value);
                reroute = true;
              } else {
                params.push(paramValue);
              }
            }
          });

        if (reroute) {
          return this.router.createUrlTree(params, {
            queryParamsHandling: '' // don't merge, fully replace with sanitized set
          });
        }
      }
    }

    return true;
  }
}
